import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserInfo as getUserInfoApi } from "../../helpers/api_helper";

export const getUserInfo = createAsyncThunk("userInfo/getUserInfo", async (credentials) => {
    try {
        const response = await getUserInfoApi(credentials);
        return response;
    } catch (error) {
        return error;
    }
});